import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ChooseJourney } from "@/components/ChooseJourney";
import { Classes } from "@/components/Classes";
import { BookingPreview } from "@/components/BookingPreview";
import { Workshops } from "@/components/Workshops";
import { Kids } from "@/components/Kids";
import { Events } from "@/components/Events";
import { Qualifications } from "@/components/Qualifications";
import { CareerTracks } from "@/components/CareerTracks";
import { Pathway } from "@/components/Pathway";
import { GlobalNetwork } from "@/components/GlobalNetwork";
import { OnlineCourses } from "@/components/OnlineCourses";
import { TrainingOnRequest } from "@/components/TrainingOnRequest";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Ecosystem } from "@/components/Ecosystem";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function HomePage() {
  usePageMeta(
    null,
    "USDD Academy — UK urban dance and creative performance academy across London & Kent. Weekly training, workshops, kids classes, events, online courses and bespoke programmes."
  );
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ChooseJourney />
        <Classes />
        <BookingPreview />
        <Workshops />
        <Kids />
        <Events />
        <Qualifications />
        <CareerTracks />
        <Pathway />
        <GlobalNetwork />
        <OnlineCourses />
        <TrainingOnRequest />
        <Testimonials />
        <Contact />
        <Ecosystem />
      </main>
      <Footer />
    </>
  );
}
